<template >

    <div class="login-bg">
    <w-app id="app" class="justify-space-between basis-zero justify-center align-center login-bg">

    <w-transition-bounce>

        <w-alert
          class="my0 mb2 text-light"
          v-if="salah"
          error
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{salah}}
        </w-alert>
    </w-transition-bounce>

    <w-notification
        v-if="$page.props.message"
        success
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.message = ''"
        >
        {{$page.props.message}}
    </w-notification>
      <main class="grow align-self-center mt10">
        <w-card class="zloglupa-title">
   
              <div class="zloglupa-logo">
                <img src="/images/logov2.png">
              </div>
              <td width="50%">
                <div class="zloglupa-title-top">ARTIFICIAL INSEMINATION MANAGEMENT SYSTEM (AIMS)</div>
              </td>
        </w-card>

        <w-card class="zloglupa">
        <w-transition-bounce>
            <w-alert
              class="my0 mb2 text-light"
              v-if="success"
              success
              transition="bounce"
              plain
              round
              no-border
              dismiss
              >
            {{ success }}
            </w-alert>
        </w-transition-bounce>
        
            <w-alert
              class="my0 mb2 text-light"
              v-if="$page.props.flash.errors"
              error
              transition="bounce"
              plain
              round
              timeout="2000"
              no-border
              dismiss
              >
                {{$page.props.flash.errors}}
            </w-alert>

        <template #buttons />

         <w-form
            @validate="changePassword"
          >

            <w-input
              outline
              label="Emel *"
              class="mt3"
              type="email"
              placeholder="Sila Masukkan Emel"
              name="email"
              v-model="form.email"
              :validators="[validators.required, validators.email]"
            />
            

            <div class="spacer"></div>

              <div class="mt5 mb5"></div>


              <w-flex justify-center align-center class="mt5">
                    <w-button
                      class="my2 btn-zloginbox grow"
                      type="submit"
                    >
                      <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon> Hantar
                    </w-button>

              </w-flex>
            <w-flex class="flex justify-center">
                <w-button
                    text
                    @click="kembaliLogin"
                >
                    <w-icon class="mr2" xs>fal fa-arrow-left</w-icon>
                    Kembali
                </w-button>
            </w-flex>


          </w-form>
        </w-card>

        <!-- <div class="zloginbox-title-footer">
              © 2022 <b>2en Apps Sdn Bhd</b><br>
              Hak Cipta Terpelihara
        </div> -->





      </main>

      <footer>
      </footer>
    </w-app>

  </div>
</template>


<script>
    
import ZResource from '@/Modules/z-resource'
import axios from 'axios';
export default {
   components: {
          axios,
        },
  extends: ZResource,
    props: {
        token: String,
        email: String
    },
  data() {
    return {
      isPassword: true,
      isPassword1: true,

      form: {
        email: '',
        password: '',
        password_confirmation: '',

      },
      success : '',
      salah : '',
      respon:'',

    }
  },
  methods: {
     changePassword() {
          if (this.form.email != '') {
              this.$zcomm.post(this.api_service + 'reset_password', this.form)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.respon = res;
                    if(res == 'Email Tidak di Jumpai!'){
                        this.form.email == '';
                        this.$zutil.notify('Email Tidak Wujud!', false);
                    }
                    if(res == 'Kata Laluan Anda Telah Berjaya Ditukar, Sila Semak Email'){
                     var mesej = 'Permintaan untuk penetapan semula kata laluan telah berjaya dihantar ke emel ' + this.form.email;
                     var mesej2 = ' \nSila semak Inbox emel anda untuk kata laluan baharu. Sekiranya tiada, semak junk mail atau folder spam.';
                         this.$zutil.notifSweet2(mesej, mesej2, 'success');
                         this.$inertia.visit(this.$route('login'));
                    }
                    console.log('asdasd');
                    console.log(respon);
                })
                .catch((err) => {

                })

                .finally(() => {
                  // this.dialog.loading = false;
                  // this.$zutil.notify('Kata Laluan Anda Telah Berjaya Ditukar, Sila Semak Email Anda.', true)

                });
               // this.$zutil.notify('Kata Laluan Anda Telah Berjaya Ditukar, Sila Semak Email Anda.', true)
          }else{
            this.notify('Sila Lengkapkan dengan benar',false);
          }

        },
        kembaliLogin() {
            this.$inertia.visit(this.$route('login'));
        },

        notify(msg, success = true) {
            if(success)

            this.success = msg
            else
            this.salah = msg
        }
  }
}
</script>

<style>
#app {
  flex-direction: column;
}
.w-app {
    background: url(/images/aiibg.png) !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
}


.zloglupa {
  background: inherit !important;
}
.zloglupa .w-card__content {
    background: #fff;
}
.zloglupa .w-toolbar {
    background-color: #0c213ab8;
    color: #fff;
}

.zloglupa-title {
    background: #0c213ab8;
    color: #fff;
    text-align: center;
    background: #7e90a4b8;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-top: 1px solid #7e90a4b8;
    border-left: 1px solid #7e90a4b8;
    border-right: 1px solid #7e90a4b8;
        margin-top:120px;

}

.zloglupa-title-top{
    font-weight: bold;
    font-size: 13px;
    text-shadow: 1px 1px black;
}
.zloglupa-title-bottom {
    margin-bottom: 10px;
    margin-top: 5px;
}
.zloglupa-logo img {
    height: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.btn-zloglupa{
    color: #fff;
    background-color: #1761fd !important;
    border-color: #1761fd !important;
    font-size: 13px !important;
    padding: 15px;
}
.zloglupa-title-footer {
    text-align: center;
    font-size: 13px;
    color: #fff;
    margin-top: 10px;
    text-shadow: 1px 1px black;
}


</style>
